<template>
  <div ref="container">
    <a-modal
      :title="title"
      :width="800"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :wrapClassName="wrapClassNameInfo()"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="保存"
      style="top:2%;height:95%;">
      <template slot="footer">
        <a-button key="back" v-if="isReadOnly" @click="handleCancel">
          取消
        </a-button>
      </template>
      <a-spin :spinning="confirmLoading">
        <a-form :form="form" id="userModal">
          <a-form-item label="登录名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="请输入登录名称" v-decorator.trim="[ 'loginName', validatorRules.loginName]" :readOnly="!!model.id" />
          </a-form-item>
          <a-form-item label="用户密码" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="!model.id">
            <a-input-password placeholder="请输入用户密码" v-decorator.trim="[ 'password', validatorRules.password]" />
          </a-form-item>
          <a-form-item label="用户姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" >
            <a-input placeholder="请输入用户姓名" v-decorator.trim="[ 'username', validatorRules.username]" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="角色">
            <a-select v-if="!model.id||model.id!==model.tenantId" placeholder="选择角色" v-decorator="[ 'roleId', validatorRules.roleId]" :dropdownMatchSelectWidth="false">
              <a-select-option v-for="(item,index) in roleList" :key="index" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-col v-if="model.id===model.tenantId"><a-row>{{ tenantRoleName }}</a-row></a-col>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门">
            <a-tree-select style="width:100%" :dropdownStyle="{maxHeight:'200px',overflow:'auto'}" allow-clear
               :treeData="orgaTree" v-decorator="[ 'orgaId' ]" placeholder="请选择部门">
            </a-tree-select>
          </a-form-item>
          <a-form-item v-if="storeOptionsReady" :labelCol="labelCol" :wrapperCol="wrapperCol" label="所属门店">
            <a-select v-model="bindStoreId" placeholder="未更改则不修改" allowClear>
              <a-select-option value="">无</a-select-option>
              <a-select-option v-for="s in storeOptionList" :key="s.id" :value="s.id">{{ s.name }}</a-select-option>
            </a-select>
            <div style="color:#999;font-size:12px;margin-top:2px">选择门店后保存时将绑定该用户到门店（收银员场景）；选择"无"则清除门店绑定</div>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="职位">
            <a-input placeholder="请输入职位" v-decorator.trim="[ 'position' ]" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否经理">
            <a-select placeholder="请选择是否经理" v-decorator="[ 'leaderFlag' ]">
              <a-select-option value="1">是</a-select-option>
              <a-select-option value="0">否</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电话号码">
            <a-input placeholder="请输入电话号码" v-decorator.trim="[ 'phonenum' ]" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电子邮箱">
            <a-input placeholder="请输入电子邮箱" v-decorator.trim="[ 'email' ]" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序">
            <a-input placeholder="请输入排序" v-decorator.trim="[ 'userBlngOrgaDsplSeq' ]" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
            <a-textarea :rows="2" placeholder="请输入备注" v-decorator="[ 'description' ]" />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
  import pick from 'lodash.pick'
  import Vue from 'vue'
  import md5 from 'md5'
  import JSelectPosition from '@/components/jeecgbiz/JSelectPosition'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import {addUser,editUser,queryOrganizationTreeList,roleAllList} from '@/api/api'
  import { storeOptions, userStoreBind } from '@/api/plugin/dining'
  import { getAction } from '@/api/manage'
  import {autoJumpNextInput} from "@/utils/util"
  import {mixinDevice} from '@/utils/mixin'
  import JImageUpload from '../../../components/jeecg/JImageUpload'
  export default {
    name: "UserModal",
    mixins: [mixinDevice],
    components: {
      JImageUpload,
      JSelectPosition
    },
    data () {
      return {
        title:"操作",
        visible: false,
        modalWidth:800,
        drawerWidth:700,
        orgaTree: [],
        roleList: [],
        userId:"", //保存用户id
        tenantRoleName: '', //租户的角色名称
        // ===== 所属门店（餐饮插件门店绑定，兼容期 jsh_store_user） =====
        storeOptionList: [], //门店选项（GET /api/plugin/dining/store/options）
        bindStoreId: undefined, //下拉当前选择（undefined=未更改不提交；''=清除绑定）
        storeOptionsReady: false, //门店接口可用且有选项时才渲染下拉
        isReadOnly: false,
        disableSubmit:false,
        dateFormat:"YYYY-MM-DD",
        validatorRules:{
          loginName:{
            rules: [{
              required: true, message: '请输入登录名称!'
            }]
          },
          password: {
            rules: [
              { required: true, message: '请输入用户密码!' },
              { pattern: /^(?=.*[a-z])(?=.*\d).{6,}$/, message: '用户密码至少要有数字和小写字母，并且长度至少6位!' }
            ]
          },
          username:{
            rules: [{
              required: true, message: '请输入用户姓名!'
            }]
          },
          roleId:{
            rules: [{
              required: true, message: '请选择角色!'
            }]
          }
        },
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        uploadLoading:false,
        confirmLoading: false,
        headers:{},
        form:this.$form.createForm(this)
      }
    },
    created () {
      const token = Vue.ls.get(ACCESS_TOKEN);
      this.headers = {"X-Access-Token":token}
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.loadOrgaData()
        this.loadRoleData()
        this.loadStoreOptions()
        this.bindStoreId = undefined
        this.form.resetFields();
        this.userId = record.id;
        this.visible = true;
        this.model = Object.assign({}, record);
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'loginName','username','roleId','orgaId','position','leaderFlag',
            'phonenum','email','userBlngOrgaDsplSeq','description'))
          this.tenantRoleName = this.model.roleName
          autoJumpNextInput('userModal')
        });
      },
      close() {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let formData = Object.assign(this.model, values);
            let obj;
            if(!this.model.id){
              formData.id = this.userId;
              formData.password = md5(values.password);
              obj=addUser(formData);
            }else{
              obj=editUser(formData);
            }
            obj.then((res)=>{
              if(res.code === 200){
                that.bindStoreAfterSave(values.loginName)
                that.$emit('ok');
                that.close();
              }else{
                that.$message.warning(res.data.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      handleCancel() {
        this.close()
      },
      // ===== 所属门店（餐饮插件门店绑定，兼容期 jsh_store_user） =====
      loadStoreOptions() {
        // 插件未安装/无门店时静默隐藏下拉；仅当接口可用且有选项时渲染
        storeOptions().then((res)=>{
          if(res && res.code === 200 && Array.isArray(res.data) && res.data.length){
            this.storeOptionList = res.data
            this.storeOptionsReady = true
          }else{
            this.storeOptionsReady = false
          }
        }).catch(()=>{
          this.storeOptionsReady = false
        })
      },
      // 保存成功后绑定门店：下拉未选择（undefined）不提交；选"无"清绑定；选门店 PUT /user/{userId}/store {storeId}
      // 简化说明：下拉不回显已绑门店（无按用户查绑定接口），编辑时保持 placeholder"未更改则不修改"
      bindStoreAfterSave(loginName) {
        if(!this.storeOptionsReady || this.bindStoreId === undefined){
          return
        }
        const doBind = (userId) => {
          userStoreBind(userId, { storeId: this.bindStoreId || '' }).catch(()=>{
            this.$message.warning('用户已保存，但门店绑定失败，请重试')
          })
        }
        if(this.model.id){
          doBind(this.model.id)
        }else{
          // 新用户：addUser 不回传 id，按登录名查回新用户 id 再绑定（与门店收银员弹窗同模式）
          getAction('/user/list', { search: JSON.stringify({ loginName: loginName }) }).then((res)=>{
            const rows = (res && res.data && res.data.rows) || []
            if(rows.length){
              doBind(rows[0].id)
            }
          }).catch(()=>{ /* 查询失败无法绑定，用户已创建成功 */ })
        }
      },
      loadOrgaData(){
        let that = this;
        let params = {};
        params.id='';
        queryOrganizationTreeList(params).then((res)=>{
          if(res){
            that.orgaTree = res
          }
        })
      },
      loadRoleData(){
        roleAllList({}).then((res)=>{
          if(res){
            this.roleList = res
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>